<template>
	<div class="vaillant">
		<AuthorizedService logo="brotje-big.png" />
		<Services />		
		<Recipients />	
		<ContactForm />		
	</div>
</template>

<script>
import AuthorizedService from '@/components/AuthorizedService.vue';
import Services from '@/components/Services.vue';
import Recipients from '@/components/Recipients.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
	name: 'Brotje',
	components: {
		AuthorizedService,
		Services,
		Recipients,
		ContactForm
	},
	metaInfo: {
		title: 'Serwis Brotje Warszawa - Instalacje centralnego ogrzewania',
		// override the parent template and just use the above title only
		titleTemplate: null,
		meta: [
			{ charset: 'utf-8' },
			{ name: 'description', content: 'Kompleksowy i profesjonalny serwis kotłów gazowych CO firmy Brotje. Naprawy gwarancyjne i pogwarancyjne, przeglądy okresowe, regulacja i konserwacja urządzeń instalacji centralnego ogrzewania.' }
		]
	}
}
</script>